import { localizedText, getLocale } from '../../common-js/LanguageMap';

export default function ($scope, $rootScope, $state, $log, $timeout, addonFactory, $window, DrawpService) {
    $scope.localizedText = localizedText;
    $scope.selectSizeHelperText = $scope.localizedText('SELECT_SLIDE_SIZE');
    
    const pageName = 'vp-math-journals';
    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;
    $scope.enableReload = true;
    $scope.stateTitle = $scope.localizedText('MATH_JOURNAL').replace(/<\/?[^>]+>/gi, ' ');
    $scope.backState = 'addonAppIndex';
    $scope.stateClass = 'vp-math-journals';
    $scope.language = 'en';
    $scope.isEnglishListActive = true;
    $scope.subscription_days = 100;
    $scope.subscription = null;
    $scope.alertMultiAccount = false;
    $scope.levelDescription = null;
    $scope.dialogTitle = 'Add to';
    const GOOGLE_SLIDE_EN_MATH_JOURNAL_BUNDLE_SUBSCRIPTION = '5f7fdefd618072070fc2b909';
    const GOOGLE_SLIDE_ES_MATH_JOURNAL_BUNDLE_SUBSCRIPTION = '5f7fdefd618072070fc2b910';

    $scope.toolId = GOOGLE_SLIDE_EN_MATH_JOURNAL_BUNDLE_SUBSCRIPTION;
    $scope.slideDialogData = {
        value: null,
        velazquez: null
    };

    let presentationId = null;
    $scope.userEmail = '';
    $scope.serverToken = '';

    $scope.supportedPageSize = [
        { 'val': 'widescreen', 'text': 'Wide Screen', 'width': 960, 'height': 540, textboxXScale: 1, textboxYScale: 1 },
        { 'val': 'overhead', 'text': 'Overhead', 'width': 720, 'height': 540, textboxXScale: .75, textboxYScale: 1 },
        { 'val': '4:3', 'text': 'On Screen Show (4:3)', 'width': 720, 'height': 540, textboxXScale: .75, textboxYScale: 1 },
        { 'val': '16:9', 'text': 'On Screen Show (16:9)', 'width': 720, 'height': 405, textboxXScale: .75, textboxYScale: .75 },
        { 'val': '16:10', 'text': 'On Screen Show (16:10)', 'width': 720, 'height': 450, textboxXScale: .75, textboxYScale: .83 } //factor is used to adjust the textbox size since textbox are maped for widescreen
    ];
    $scope.pageSize = 'widescreen';
    $scope.pageSizeHideShowToggle = true;
    $scope.isPageSizeAutoDetected = false;
    let elPageSize = null;

    let elementLevel = null;
    let alertDialog = null;

    const ERROR_MESSAGE = addonFactory.API_CALL_ERROR.GENERICERROR;

    $scope.vpGraphicOrganizers = [];
    $scope.vpFrames = [];
    $scope.vpFrameLevel = '1';

    let insertTextDebounce = false;

    const showProgress = (show, message) => {

        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.error = message;
                if (message === addonFactory.API_CALL_ERROR.QUOTAERROR) {
                    $scope.enableReload = false;
                } else {
                    $scope.enableReload = true;
                }
            }
        });
    };

    const errorHandler = (error) => {
        const errorResp = addonFactory.errorHandler(error, $scope);
        showError(true, errorResp);
    };

    const setLevelDescription = () => {
        $timeout(() => {
            if ($scope.vpFrameLevel === '1') {
                $scope.levelDescription = $scope.localizedText('LEVEL_1_DESCRIPTION');
            } else if ($scope.vpFrameLevel === '2') {
                $scope.levelDescription = $scope.localizedText('LEVEL_2_DESCRIPTION');
            } else {
                $scope.levelDescription = null;
            }
        });
    };

    const getMathJournalResources = () => {
        showProgress(true, progressText);

        Promise.all([DrawpService.getVelazquezMathJournalGraphics($scope.language, $scope.serverToken),
        DrawpService.getVelazquezMathJournalFrames($scope.language, $scope.vpFrameLevel, $scope.serverToken)]).then((results) => {
            showProgress(false, '');
            if (results[0] != null && results[1] != null) {

                // const responseDataOne = results[0];
                // const responseDataTwo = results[1];

                const responseDataOne = JSON.parse(JSON.stringify(results[0].data).replaceAll('moondrawp.xyz', 'drawpforschool.com'));
                const responseDataTwo = JSON.parse(JSON.stringify(results[1].data).replaceAll('moondrawp.xyz', 'drawpforschool.com'));

                $scope.subscription_days = responseDataOne.subscription_data.subscription_expired;
                $scope.subscription = $scope.subscription_days != null && $scope.subscription_days > 0;

                $timeout(() => {
                    $scope.vpGraphicOrganizers = responseDataOne.sections;
                    $scope.vpFrames = responseDataTwo.frames;
                });

                elementLevel = mdc.select.MDCSelect.attachTo(document.querySelector('#level'));
                elementLevel.selectedIndex = 0;

                setLevelDescription();

                elementLevel.listen('MDCSelect:change', () => {
                    if ($scope.subscription) {
                        $timeout(() => {
                            $scope.vpFrameLevel = elementLevel.value;
                        });

                        showProgress(true, progressText);
                        DrawpService.getVelazquezMathJournalFrames($scope.language, elementLevel.value, $scope.serverToken).then((result) => {
                            showProgress(false, '');
                            const responseData = JSON.parse(JSON.stringify(result.data).replaceAll('moondrawp.xyz', 'drawpforschool.com'));
                            // const responseData = result;
                            if (responseData != null) {
                                $timeout(() => {
                                    $scope.vpFrames = [];
                                });

                                $timeout(() => {
                                    $scope.vpFrames = responseData.frames;

                                    $scope.subscription_days = responseData.subscription_data.subscription_expired;
                                    $scope.subscription = $scope.subscription_days != null && $scope.subscription_days > 0;

                                    setLevelDescription();
                                });
                            }
                        }).catch((err) => {
                            showProgress(false, '');
                            errorHandler(err);
                        });
                    }
                });
            }
        }).catch((err) => {
            showProgress(false, '');
            errorHandler(err);
        });
    };

    const detectSlideSize = async () => {
        try {
            const size = await DrawpService.getPresentationSlideSize();
            if (size) {
                console.log("Detected presentation slide size:", size);
                let bestMatch = $scope.supportedPageSize.find((item) =>
                    item.width === size.width && item.height === size.height
                );

                if (!bestMatch) {
                    bestMatch = $scope.supportedPageSize.find((item) =>
                        Math.abs(item.width - size.width) < 5 && Math.abs(item.height - size.height) < 5
                    );
                }

                if (bestMatch) {
                    return await $timeout(() => {
                        $scope.pageSize = bestMatch.val;
                        $scope.pageSizeHideShowToggle = false;
                        $scope.isPageSizeAutoDetected = true;
                        return bestMatch;
                    });
                }
            }
        } catch (error) {
            console.error("Error auto-detecting slide size:", error);
        }
        return null;
    };

    const init = () => {
        showProgress(true, progressText);
        getMathJournalResources();
    };

    angular.element(document).ready(() => {
        // presentationId = document.getElementById('presentationId').textContent.trim();
        // $scope.userEmail = document.getElementById('userEmail').textContent.trim();
        // $scope.serverToken = document.getElementById('serverToken').textContent.trim();
        alertDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#alert_dialog'));

        elPageSize = mdc.select.MDCSelect.attachTo(document.querySelector('#slide-page-setup'));
        elPageSize.listen('MDCSelect:change', () => {
            $scope.pageSize = elPageSize.value;
        });

        // if (addonFactory.isMultiAccountActive() != null) {
        //     $scope.alertMultiAccount = addonFactory.isMultiAccountActive();
        // }

        DrawpService.gAPageview(pageName, pageName, null, null, $scope.userEmail, $scope.serverToken);

        detectSlideSize();
        init();
    });

    $scope.onPurchaseClick = (book, sentence) => {
        if (!DrawpService.isLoggedIn()) {
            $scope.launchSnackBar('Please login to purchase this tool.', 'Ok', true);
        } else {
            if (book != null) {
                if ($scope.language === 'en') {
                    DrawpService.gAPurchaseButtonSelectedEvent(12, $scope.language, book.id, book.name, $scope.serverToken);
                    DrawpService.goToPaymentScreen("12", $scope.language, book.id, book.name, $state);
                } else if ($scope.language === 'es') {
                    DrawpService.gAPurchaseButtonSelectedEvent(13, $scope.language, book.id, book.name, $scope.serverToken);
                    DrawpService.goToPaymentScreen("13", $scope.language, book.id, book.name, $state);
                }
            } else if (sentence != null) {
                if ($scope.language === 'en') {
                    DrawpService.gAPurchaseButtonSelectedEvent(12, $scope.language, null, null, $scope.serverToken);
                    DrawpService.goToPaymentScreen("12", $scope.language, null, null, $state);
                } else if ($scope.language === 'es') {
                    DrawpService.gAPurchaseButtonSelectedEvent(13, $scope.language, null, null, $scope.serverToken);
                    DrawpService.goToPaymentScreen("13", $scope.language, null, null, $state);
                }
            }
        }
    };

    const insertSlidesToPresentation = async (velazquez, destIndex) => {
        await detectSlideSize();

        const findPageSetup = $scope.supportedPageSize.find((item) => item.val === $scope.pageSize);

        showProgress(true, progressText);
        DrawpService.addVelazquezSlides(presentationId, [], velazquez, destIndex, $scope.language, findPageSetup.width, findPageSetup.height, findPageSetup.textboxXScale, findPageSetup.textboxYScale).then(() => {
            $timeout(() => {
                showProgress(false, '');
            });

            if (destIndex == null)
                $scope.launchSnackBar($scope.localizedText('SLIDE_ADDED_TO_PRESENTATION'), 'Ok', true);
            else
                $scope.launchSnackBar(`Slides has been added to the presentation after slide ${destIndex + 1}.`, 'Ok', true);

            DrawpService.gABasicEvent('insert_vp_math_journal', {
                username: $scope.userEmail,
                pageName,
                toolName: pageName,
                book_id: velazquez.id,
                book_name: velazquez.name,
                language: $scope.language
            }, $scope.serverToken);
        }).catch((error) => {
            const errorResp = addonFactory.errorHandler(error, $scope);

            $timeout(() => {
                showProgress(false, '');
                $scope.error = errorResp;
            });
        });
    };

    $scope.addToPresentation = (velazquez) => {
        if (velazquez.premium && $scope.subscription) {
            showProgress(true, progressText);
            // DrawpService.getActiveSlideId(presentationId).then((response) => {
            //     showProgress(false, '');
            //     if (response === 200) {
            insertSlidesToPresentation(velazquez, null);
            // } else if (typeof response !== 'number') {
            //     $scope.slideDialogData.value = null;
            //     $scope.slideDialogData.velazquez = velazquez;

            // DrawpService.gABasicEvent('select_slide_dialog_show', {
            //     username: $scope.userEmail,
            //     pageName,
            //     total_slides: response.length
            // }, $scope.serverToken);

            // $timeout(() => {
            //     $scope.dialogTitle = 'Add after';
            //     $scope.showSelectSlideDialog(response);
            // });
            // } else {
            //     $scope.launchSnackBar('Slides processing not possible. Please try again.', 'Ok', true);
            // }
            // }).catch((error) => {
            //     errorHandler(error);
            // });
        }
    };

    $scope.onLanguageToggle = () => {
        $scope.isEnglishListActive = !$scope.isEnglishListActive;

        if ($scope.isEnglishListActive) {
            $scope.language = 'en';
            $scope.toolId = GOOGLE_SLIDE_EN_MATH_JOURNAL_BUNDLE_SUBSCRIPTION;
        } else {
            $scope.language = 'es';
            $scope.toolId = GOOGLE_SLIDE_ES_MATH_JOURNAL_BUNDLE_SUBSCRIPTION;
        }

        $timeout(() => {
            $scope.vpFrames = [];
        });

        init();
    };

    $scope.snackBarUtil = (show, messageText, actionText) => {
        // if (addonFactory.isMultiAccountActive() != null) {
        //     $scope.alertMultiAccount = addonFactory.isMultiAccountActive();
        // }

        // if (!$scope.alertMultiAccount) {
        //     return;
        // }

        $scope.launchSnackBar(messageText, actionText, show);
    };

    const showDialog = (message) => {
        $scope.nameOfTheTool = message;
        alertDialog.open();
    };

    const insertSentence = (value, destIndex) => {
        showProgress(true, progressText);
        DrawpService.insertQuestionSet(value, null, false, presentationId, destIndex).then((slideId) => {
            showProgress(false, '');

            if (slideId == null) {
                showError(true, ERROR_MESSAGE);
            } else {
                $scope.snackBarUtil(true, `Text box has been added to active slide of the presentation.`, 'Ok');
                // $scope.snackBarUtil(true, `Text box has been added to slide ${destIndex + 1} of the presentation.`, 'Ok');
            }

            DrawpService.gABasicEvent('insert_vp_math_journal_sentence_frame', {
                username: $scope.userEmail,
                pageName,
                toolName: pageName,
                text: value.text,
                language: $scope.language,
                level: $scope.vpFrameLevel
            }, $scope.serverToken);
        }).catch((error) => {
            errorHandler(error);
        });
    };

    $scope.insertSentenceFrame = (value) => {
        if ($scope.subscription_days == null || $scope.subscription_days <= 0) {
            if (insertTextDebounce) {
                return;
            }

            setTimeout(() => {
                insertTextDebounce = false;
            }, 1000);

            insertTextDebounce = true;

            if ($scope.language === 'en') {
                showDialog('Math Journals (English)');
            } else {
                showDialog('Math Journals (Spanish)');
            }
        } else {
            showProgress(true, progressText);
            // DrawpService.getActiveSlideId(presentationId).then((response) => {
            //     showProgress(false, '');
            //     if (response === 200) {
            insertSentence(value, null);
            // } else if (typeof response !== 'number') {
            //     $scope.slideDialogData.value = value;
            //     $scope.slideDialogData.parentPresentationId = null;

                // DrawpService.gABasicEvent('select_slide_dialog_show', {
                //     username: $scope.userEmail,
                //     pageName,
                //     total_slides: response.length
                // }, $scope.serverToken);

            //     $timeout(() => {
            //         $scope.dialogTitle = 'Add to';
            //         $scope.showSelectSlideDialog(response);
            //     });
            // } else {
            //     $scope.launchSnackBar('Text Sticker processing not possible. Please try again.', 'Ok', true);
            // }
            // }).catch((error) => {
            // errorHandler(error);
            // });
        }
    };

    $scope.reloadCurrentPage = () => {
        $state.go($state.current.name, {}, { reload: true });
    };

    $scope.onSlideSelected = (destIndex, totalSlides) => {
        DrawpService.gABasicEvent('select_slide_dialog_selection', {
            username: $scope.userEmail,
            pageName,
            total_slides: totalSlides,
            selected_slide: destIndex + 1
        }, $scope.serverToken);

        if ($scope.slideDialogData.value != null)
            insertSentence($scope.slideDialogData.value, destIndex);
        else if ($scope.slideDialogData.velazquez != null)
            insertSlidesToPresentation($scope.slideDialogData.velazquez, destIndex);

        $scope.hideSelectSlideDialog();
    };

    $scope.pageSizeHideShowToggleView = (value) => {
        $scope.pageSizeHideShowToggle = value;
    }
};